import { SessionAddress } from '@updater-core/interactors/shell/session/interactor.d';
import { format } from '@updater-core/lib/date';

const HOME_SIZE = {
  studio: 'Studio',
  one_bed: '1 Bedroom',
  two_bed: '2 Bedroom',
  three_bed: '3 Bedroom',
  three_bed_plus: '3 Bedroom',
  four_bed_plus: '4+ Bedroom',
};

const COST = {
  studio: 399,
  one_bed: 499,
  two_bed: 599,
};

export function mapAddress({
  street,
  apt,
  city,
  state,
  zip,
}: // eslint-disable-next-line no-undef
Partial<SessionAddress>): any {
  return {
    street,
    unit: apt || '',
    city,
    state,
    postalCode: zip,
  };
}

export function formatAddress(
  address: SessionAddress,
  short: boolean = false
): string {
  if (short) {
    return `${address.street}`;
  }
  return `${address.street}, ${address.city}`;
}

export function formatHomeSize(homeSize: string): string {
  return HOME_SIZE[homeSize];
}

export function calculateCost(homeSize: string): number {
  return COST[homeSize];
}

export function formatDate(
  date: string,
  dateFormat: string = 'EEEE, MMMM d'
): string {
  const formattedDate = new Date(`${date}`);
  if (Number.isNaN(formattedDate)) {
    return '';
  }
  const dateOnly = new Date(
    formattedDate.valueOf() + formattedDate.getTimezoneOffset() * 60 * 1000
  );
  return format(dateOnly, dateFormat);
}

export function formatDateTime(
  date: string,
  time: string,
  short: boolean = false
): string {
  const dateTime = Date.parse(`${date}T${time}`);
  if (Number.isNaN(dateTime)) {
    return '';
  }
  if (short) {
    return format(dateTime, 'EEE, d MMM - h:mm aaaa');
  }
  return format(dateTime, 'EEEE, MMMM d @ h:mm aaaa');
}
function getAppointmentDetails(
  id: string,
  availableTimes
): { window: string; date: string } {
  return availableTimes?.find((appointment) => `${appointment.id}` === `${id}`);
}

export function getArrivalTime(id: string): string | undefined {
  try {
    const { arrivalWindow } = JSON.parse(id);
    return arrivalWindow;
  } catch (error) {
    return undefined;
  }
}

export function normalizeDateString(str) {
  return str?.split('/').join('-');
}

export function getArrivalDate(
  id: string,
  availableTimes,
  formatted: boolean = true
): string {
  const item = getAppointmentDetails(id, availableTimes);
  if (!item) return '';
  return formatted ? formatDate(item.date) : normalizeDateString(item.date);
}

export function getIterableAddress({
  street,
  unit,
  city,
  state,
  postalCode,
}: {
  street: string;
  unit: string | undefined;
  city: string;
  state: string;
  postalCode: string;
}): {
  line1: string;
  line2: string;
  state: string;
  city: string;
  // eslint-disable-next-line camelcase
  postal_code: string;
} {
  return {
    line1: street,
    line2: unit || '',
    state,
    city,
    postal_code: postalCode,
  };
}
